export default __webpack_public_path__ + "static/media/problemsolving.34624373.png";